export const MEM_SPACE_ACCOUNT_ID = "1dba8031-d1e0-5f5d-bbd4-0b6b44774680";
